import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

export const BySituationAnual = () => {
    const { chartData } = usePoliceChartsDataContext();

    const { subtitles, series } = useMemo(() => {
        // 1. Sort the items chronologically by year
        const items = (chartData?.bySituationAnual || [])
            .slice()
            .sort((a, b) => Number(a?.ano_estatistica || 0) - Number(b?.ano_estatistica || 0));

        // 2. Map the X-axis labels (years)
        const subtitles = items.map((item) => getYearLabel(item?.ano_estatistica));

        // 3. Dynamically find all unique situation names present in the dataset
        const uniqueSituations = Array.from(
            new Set(
                items.flatMap(item => (item?.situacoes || []).map(c => c.situacao))
            )
        );

        // 4. Build the series arrays dynamically based on the found situations
        const series = uniqueSituations.map(situationName => ({
            name: situationName,
            data: items.map(item => {
                const situation = (item?.situacoes || []).find(c => c.situacao === situationName);
                return Number(situation?.total || 0); // Returns 0 if this specific situation doesn't exist in that year
            })
        }));

        return { subtitles, series };
    }, [chartData]);

    return (
        <SimpleBars
            title="Por Situação (Anual)"
            horizontal={true}
            subtitles={subtitles}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
